import {
  ApiCartChangeCartContactRequestedAction,
  apiCartChangeCartContactFailed,
  apiCartChangeCartContactSucceeded
} from '../../../api/cart/changeCartContactApi';
import { call, put } from 'typed-redux-saga';
import changeCartContactAction, {
  ChangeCartContactActionInput,
  ChangeCartContactActionResult
} from '@spa/lib/actions/cart/changeCartContactAction';

function* changeCartContactSaga({
  payload: { actionId: requestedActionId, contact, customOrderType, parentActionId }
}: ApiCartChangeCartContactRequestedAction): Generator {
  try {
    const input: ChangeCartContactActionInput = { customOrderType, contact };
    const { cartId, result }: ChangeCartContactActionResult = yield* call(
      changeCartContactAction,
      'changeCartContactAction',
      input
    );
    yield* put(
      apiCartChangeCartContactSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartContactFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartContactSaga;
